/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsdoc/require-returns */
/* 
    cách hoạt động của việc show/hide field
    Sau khi render xong, Check setting 'links' để so sánh điều kiện show/hide
    => xây dựng được map show/hide
    => thực hiện show/hide
*/
import store from '@/app/store/store';

interface showFieldItem {
  value: any;
  show: boolean;
  showData: boolean[];
  links: any[];
}
interface arrayShowFields {
  [index: string]: showFieldItem;
}

let _mapFields: arrayShowFields = {};
let _mapNoFields: string[] = [];

/**
 * Mỗi lần dữ liệu được cập nhật cần reset lại showData
 */
const resetShowData = (): void => {
  for (const key in _mapFields) {
    if (!Object.prototype.hasOwnProperty.call(_mapFields, key)) continue;
    _mapFields[key].showData = [];
  }
};

/**
 * Kiểm tra xem field đó được phép hiển thị hay không
 * @returns Nếu được phép => true | Nếu không được phép => false
 * @param field showFieldItem
 */
const isShow = (field: showFieldItem): boolean => {
  let show = field.show;
  if (field.showData.length > 0) {
    let tempShow = false;
    const showData = field.showData;
    for (let j = 0; j < showData.length; j++) {
      if (showData[j]) {
        tempShow = true;
        break;
      }
    }

    show = tempShow;
  }
  return show;
};

/**
 * Push show vào showData
 * @param ids list ids
 * @param show true, false
 */
const addShowData = (ids: string[], show: boolean): void => {
  if (!ids || ids.length < 1) return;
  for (let i = 0; i < ids.length; i++) {
    _mapFields[ids[i]].showData.push(show);
  }
};

/**
 * Function chạy theo thứ tự _mapNoFields
 * Kiểm tra xem field nào có links và được hiển thị
 * Thì addShowData cho cho ids nằm trong link
 */
const linkFields = (): void => {
  for (let i = 0; i < _mapNoFields.length; i++) {
    const key = _mapNoFields[i];
    if (!Object.prototype.hasOwnProperty.call(_mapFields, key)) continue;
    const field = _mapFields[key];

    if (field.links && field.links.length > 0 && isShow(field)) {
      for (let h = 0; h < field.links.length; h++) {
        //check with value
        if (field.links[h].value == field.value) {
          //set with id
          let ids = [];
          if (field.links[h].id) {
            ids.push(field.links[h].id);
          } else if (field.links[h].ids && field.links[h].ids.length > 0) {
            ids = field.links[h].ids;
          }

          addShowData(ids, field.links[h].show);
        }
      }
    }
  }
};

/**
 * Gọi mỗi khi data được cập nhật
 * Mặc định render ra là show => thực hiện thao tác hide
 * Gán show  = default show
 * Chỉ cần 1 thằng trong showData == true => show
 * tất cả showData == false => hide
 * Không có showData => xài default show
 */
const showFormField = (): void => {
  resetShowData();
  linkFields();
  // TODO: Sau khi chuyển hết MERs sang Atom thì sẽ sửa lại hẳn đoạn này chỉ tìm nguyên #md-link thôi
  const $element = jQuery(
    '#gfLeftSideBar #md-module .md-body.settings-panel, #gfLeftSideBar #md-link .md-body.settings-panel',
  );
  //ẩn hiện field
  for (const key in _mapFields) {
    if (!Object.prototype.hasOwnProperty.call(_mapFields, key)) continue;

    const field = _mapFields[key];
    const show = isShow(field);
    const $item = $element.find('#' + key);
    if (!show) {
      if ($item.hasClass('gfDesc')) {
        $item.addClass('gf-field-hidden');
      } else {
        $item.next().addClass('gf-field-hidden');
      }

      //hot fix for gfPhotoPicker
      if ($item.hasClass('gf_to-photoPicker')) {
        $item.next().next().addClass('gf-field-hidden').next().addClass('gf-field-hidden');
      }
    } else {
      if ($item.hasClass('gfDesc')) {
        $item.removeClass('gf-field-hidden');
      } else {
        $item.next().removeClass('gf-field-hidden');
      }

      //hot fix for gfPhotoPicker
      if ($item.hasClass('gf_to-photoPicker')) {
        $item.next().next().removeClass('gf-field-hidden').next().removeClass('gf-field-hidden');
      }
    }
  }

  //ẩn hiên colums advanced
  $element.find('.columns-advanced').each(function () {
    const $colAdvanced = jQuery(this);
    //ẩn hiện wrap box
    $colAdvanced.find('.gfSGSettings').each(function () {
      const $gfFieldItem = jQuery(this).find('.gf-field-item');
      if (!$gfFieldItem.length) {
        return;
      }

      let show = false;
      $gfFieldItem.each(function () {
        if (jQuery(this).hasClass('gfDesc')) {
          if (!jQuery(this).hasClass('gf-field-hidden')) {
            show = true;
            return;
          }
        } else {
          if (!jQuery(this).next().hasClass('gf-field-hidden')) {
            show = true;
            return;
          }
        }
      });

      if (!show) {
        $colAdvanced.addClass('gf-field-hidden');
        $colAdvanced.prev().find('.gfSGAdv').addClass('gf-field-hidden');
      } else {
        $colAdvanced.removeClass('gf-field-hidden');
        $colAdvanced.prev().find('.gfSGAdv').removeClass('gf-field-hidden');
      }
    });
  });

  $element.find('.columns').each(function () {
    const $col = jQuery(this);
    //ẩn hiện wrap box
    $col.find('.gfSGSettings').each(function () {
      const $gfFieldItem = jQuery(this).find('.gf-field-item');
      if (!$gfFieldItem.length) {
        return;
      }

      let show = false;
      $gfFieldItem.each(function () {
        if (jQuery(this).hasClass('gfDesc')) {
          if (!jQuery(this).hasClass('gf-field-hidden')) {
            show = true;
            return;
          }
        } else {
          if (!jQuery(this).next().hasClass('gf-field-hidden')) {
            show = true;
            return;
          }
        }
      });

      //check button advaned
      const $gfSGAdv = jQuery(this).find('.gfSGAdv');
      if ($gfSGAdv.length && !$gfSGAdv.hasClass('gf-field-hidden')) {
        show = true;
      }

      if (!show) {
        $col.addClass('gf-field-hidden');
      } else {
        $col.removeClass('gf-field-hidden');
      }
    });
  });
};

/**
 * Add data cho _mapFields: arrayShowFields
 * Add data cho _mapNoFields: lưu thứ tự của field
 * @param key là id của field
 * @param fieldData là showFieldItem
 */
const pushMapFields = (key: string, fieldData: showFieldItem): void => {
  _mapFields[key] = fieldData;
  _mapNoFields.push(key);
};

/**
 * Ép kiểu cho show vì có trường hợp show undefined hoặc string "true" "false"
 * @returns true | false
 * @param show giá trị show của field settings
 */
const initShow = (show: any): boolean => {
  if (show == undefined) {
    return true;
  }
  return !!show;
};

/**
 * Khởi tạo FieldMap
 * @param fields settings của snippet
 */
const initFieldMap = (fields: any): void => {
  _mapFields = {};
  _mapNoFields = [];
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i];

    //nomarl field
    if (field.type != 'group') {
      const fieldItem = field;
      const fieldData: showFieldItem = {
        value: fieldItem.default_value,
        show: initShow(fieldItem.show),
        showData: [],
        links: fieldItem.links,
      };
      pushMapFields(fieldItem.id, fieldData);
    }

    //group
    if (field.type == 'group' && field.items && field.items.length > 0) {
      for (let h = 0; h < field.items.length; h++) {
        const fieldItem = field.items[h];
        const fieldData: showFieldItem = {
          value: fieldItem.default_value,
          show: initShow(fieldItem.show),
          showData: [],
          links: fieldItem.links,
        };
        pushMapFields(fieldItem.id, fieldData);
      }
    }

    //advanced
    if (field.advanced != undefined && field.advanced && field.advanced.length > 0) {
      for (let h = 0; h < field.advanced.length; h++) {
        const fieldItem = field.advanced[h];
        const fieldData: showFieldItem = {
          value: fieldItem.default_value,
          show: initShow(fieldItem.show),
          showData: [],
          links: fieldItem.links,
        };
        pushMapFields(fieldItem.id, fieldData);
      }
    }
  }
};

/**
 * Lấy giá trị của __currentSettings lưu trong store
 * @returns __currentSettings
 */
const getCurrentSettings = (): any => {
  return JSON.parse(JSON.stringify(store.getValue('__currentSettings')));
};

/**
 * initFieldMap sau đó lưu map vào store "__currentSettings"
 * @param fields settings của snippet
 * @returns map
 */
export default (fields: any): arrayShowFields => {
  initFieldMap(fields);
  store.setValue('__currentSettings', _mapFields);
  return _mapFields;
};

/**
 * Cập nhật lại store "__currentSettings" khi có field value thay đổi
 * @param key id của field
 * @param value value được cập nhật
 */
export const updateCurrentSettings = (key: string, value: any): void => {
  const currentSettings = getCurrentSettings();
  if (!Object.prototype.hasOwnProperty.call(currentSettings, key)) return;

  currentSettings[key].value = value;
  store.setValue('__currentSettings', currentSettings);
};

/**
 * Lắng nghe store "__currentSettings" khi có sự thay đổi
 * Lấy ra _mapFields
 * Thực hiện showFormField
 */
store.onChange('__currentSettings', () => {
  _mapFields = getCurrentSettings();
  showFormField();
});
